import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteInstallemntsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/deleteInstallment',
      requesterInfo,
    })
  }

  public async deleteInstallemnts(request: number[]): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
